export default __webpack_public_path__ + "static/media/devon-looking-up.eb278066.jpg";